import { render, staticRenderFns } from "./corporate-news-item.vue?vue&type=template&id=524efd17&"
import script from "./corporate-news-item.vue?vue&type=script&lang=js&"
export * from "./corporate-news-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports